import React from 'react'
import FlexView from 'react-flexview/lib'
import { ReactComponent as MotorcycleSvg } from '../../assets/motorcycle2.svg'
import './MotorcycleBlockView.scss'

export const MotorcycleBlockView = ({ motorcycle }) => {
  return (
    <>
      <FlexView vAlignContent={'center'}>
        {motorcycle.model && (
          <>
            <MotorcycleSvg className="x-large-icon margin-left-small" />
            <div className="m-details-block">
              <div className="text-small black margin-top-small">
                <span className="bold">Make:</span> {motorcycle.make}
              </div>
              <div className="text-small black margin-top-small">
                <span className="bold">Model:</span> {motorcycle.model}
              </div>
              <div className="text-small black margin-top-small">
                <span className="bold">Year:</span> {motorcycle.year}
              </div>
            </div>
          </>
        )}
        {motorcycle.new_vehicle_req_details && motorcycle.type == '' && (
          <>
            <MotorcycleSvg className="x-large-icon margin-left-small" />
            <div className="m-details-block">
              <div className="text-small black margin-top-small">
                <span className="bold">Custom motorcycle:</span> {motorcycle.new_vehicle_req_details}
              </div>
            </div>
          </>
        )}
        {!motorcycle.model && !motorcycle.new_vehicle_req_details && <div className="text-body black">Tell us about your motorcycle</div>}
      </FlexView>
    </>
  )
}
